import usePaypalStore from "./paypal";
const useSistemaStore = defineStore("sistema", () => {
  // state
  const sistema = ref({
    id: null,
    nombre: "",
    descripcion: "",
    cuenta: null,
    paypal: false,
    paypal_id: null,
    paypal_secret: null,
    production_paypal: false,
    cuenta: null,
    ia_api_key: null,
    precio_pagina: 0,
  });

  // getters

  const draft = computed(() => clone(sistema.value));
  const saldo = computed(() =>
    sistema.value.cuenta ? sistema.value.cuenta.saldo : 0
  );

  // mutations

  const setSistema = (sistem) => {
    sistema.value = sistem;
    const paypal_store = usePaypalStore();
    paypal_store.setPaypal({
      paypal: sistem.paypal,
      paypal_id: sistem.paypal_id,
      paypal_secret: sistem.paypal_secret,
      production_paypal: sistem.production_paypal,
    });
  };

  // actions
  const fetch = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/sistemas/fetch`)
        .then(({ data }) => {
          setSistema(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchPublic = () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`api/get/data-sistema`)
        .then(({ data }) => {
          setSistema(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardar = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/sistemas/${sistema.value.id}`, datos)
        .then(({ data }) => {
          if (data.result) setSistema(data.sistema);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const crearCuenta = async () => {
    try {
      const { data } = await axios.get(`/api/sistemas/crear/cuenta`);
      if (data.result) setSistema(data.sistema);
      return data;
    } catch (error) {
      throw error;
    }
  };

  return {
    sistema,
    draft,
    saldo,
    setSistema,
    fetch,
    fetchPublic,
    guardar,
    crearCuenta,
  };
});

export default useSistemaStore;
